import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LIVE_LINK } from "../helpers/url_helper";

export const infoApi = createApi({
  reducerPath: "infoApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/priority` }),
  endpoints: (builder) => ({
    getBoardContent: builder.query({
      query: (key) => `/board-info?key=${key}`,
    }),
    updateBoardContent: builder.mutation({
      query: ({ key, content, notify }) => ({
        url: "/board-info",
        method: "PUT",
        body: { key, content, notify },
      }),
    }),
    deleteBoardContent: builder.mutation({
      query: (key) => ({
        url: `/board-info?key=${key}`,
        method: "DELETE",
      }),
    }),
  }),
});
